<template>
  <b-navbar
    fixed="top"
    variant="white">
    <b-navbar-brand
      to="/"
      class="app-sidebar-brand text-center py-0">
        <span>
            <img
              src="@/assets/logo.png"
              alt="logo-text"
              class="dark-logo"
              height="40"/>
          </span>
    </b-navbar-brand>
    <b-navbar-nav
      class="ml-auto px-4">
      <b-nav-item
        v-if="isSignedIn"
        href="#"
        @click="signOut">
        <span class="ti-power-off"></span>
        {{ $t('message.appHeader.btn.signOut') }}
      </b-nav-item>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
  export default {
    name: 'AppHeader',
    computed: {
      isSignedIn () {
        if (Object.keys(this.$store.getters.currentUser).length > 0) {
          return true
        }
        return false
      }
    },
    methods: {
      signOut () {
        this.$store.dispatch('signOut')
          .then(() => {
            this.$store.commit('setCurrentUser', {})
            this.$router.replace('/signin')
          })
      }
    }
  }
</script>

<style scoped>
  .app-sidebar-brand {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/AppHeader.vue